// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBmHMMBlJz415IYd8GCfGh6usrO5x5-SXw",
  authDomain: "uncannny-valley.firebaseapp.com",
  projectId: "uncannny-valley",
  messagingSenderId: "622447237312",
  storageBucket: "uncannny-valley.firebasestorage.app",
  appId: "1:622447237312:web:26eeb962d4039bd0703525",
  measurementId: "G-4QCJL2HXTW"
};  

// Initialize Firebase
const app = initializeApp(firebaseConfig);


const storage = getStorage(app);
const db = getFirestore(app); // 👈 add this

export { storage, db };

